// extracted by mini-css-extract-plugin
export default {"navLinks":"Nav_navLinks__v5mPQ","logo":"Nav_logo__NuKcq","line":"Nav_line__3mlds"};